module.exports = __webpack_public_path__ + "static/images/smartspot-performance-ja.c584d77d98881ec49d3daea4a140dd1b.png";